console.log('top');

const isAndroid = /Android/i.test(navigator.userAgent);
const section = document.querySelector('.mv');
const video = document.querySelector('.bgVideo');


console.log(isAndroid);
if (isAndroid) {
    document.body.classList.add('is-android');

    const toggle = () => {
        const rect = section.getBoundingClientRect();
        const inView = rect.top < window.innerHeight && rect.bottom > 0;
    
        if (inView) {
            video?.classList.add('is-show');
            video.play();
        } else {
            video?.classList.remove('is-show');
            video.pause();
        }
    };
    
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
} else {
    document.body.classList.add('is-ios');
}




/* スクロールフェード切り替え用 */
const height = window.innerHeight;
let fadeTarget = document.querySelectorAll('.mv');
const concept = document.querySelector('.concept .box1');
const navList = document.querySelector('.navList');
window.addEventListener('scroll', () => {
    for (let i = 0; i < fadeTarget.length; i++) {
        const rect = fadeTarget[i].getBoundingClientRect().top;
        const scroll = window.scrollY || document.documentElement.scrollTop;
        const offset = rect + scroll;
        const windowHeight = window.innerHeight; // 現在のブラウザの高さ

        if (scroll > offset - windowHeight + height * 1.5) {
            fadeTarget[i].classList.add('scrollin');
            concept?.classList.add('scrollin');
        } else {
            fadeTarget[i].classList.remove('scrollin');
            concept?.classList.remove('scrollin');
        }

        if (scroll > offset - windowHeight + height * 1.8) {
            navList?.classList.add('active');
        } else {
            navList?.classList.remove('active');
        }
    }
});



/*
section: data-area
切り替えるコンテンツ
*/

// document.addEventListener("DOMContentLoaded", () => {
//     const sections = document.querySelectorAll("[data-area]");
//     sections.forEach(section => {
//         const trigger = section.querySelector("[data-trigger]");
//         const boxes = section.querySelectorAll("[data-box]");

//         if (!trigger || boxes.length < 2) return;

//         let lastY = window.scrollY;
//         const showBox = (index) => {
//             boxes.forEach((box, i) => {
//                 box.classList.toggle("show", i === index);
//             });
//         };

//         const onScroll = () => {
//             const y = window.scrollY;
//             const down = y > lastY;
//             lastY = y;
//             const triggerTop = trigger.getBoundingClientRect().top;
//             const line = window.innerHeight * 0.7; // ← 50vhライン
//             const passed = triggerTop <= line;

//             if (down) {
//                 if (passed) showBox(1);
//                 else showBox(0);
//             } else {
//                 if (!passed) showBox(0);
//                 else showBox(1);
//             }
//         };
//         window.addEventListener("scroll", onScroll, { passive: true });
//         onScroll();
//     });
// });

document.addEventListener("DOMContentLoaded", () => {
    const sections = [...document.querySelectorAll("[data-area]")].map((section) => {
      const trigger = section.querySelector("[data-trigger]");
      const boxes = [...section.querySelectorAll("[data-box]")];
  
      if (!trigger || boxes.length < 2) return null;
  
      return {
        trigger,
        boxes,
        currentIndex: -1,
      };
    }).filter(Boolean);
  
    if (!sections.length) return;
  
    let ticking = false;
    let line = window.innerHeight * 0.7;
  
    const showBox = (item, index) => {
      if (item.currentIndex === index) return;
      item.currentIndex = index;
  
      item.boxes.forEach((box, i) => {
        box.classList.toggle("show", i === index);
      });
    };
  
    const update = () => {
      sections.forEach((item) => {
        const passed = item.trigger.getBoundingClientRect().top <= line;
        showBox(item, passed ? 1 : 0);
      });
  
      ticking = false;
    };
  
    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
  
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", () => {
      line = window.innerHeight * 0.7;
      requestUpdate();
    });
  
    update();
  });



/*マウスストーカー*/
if (window.matchMedia('(min-width: 769px)').matches) {
    document.addEventListener('DOMContentLoaded', () => {
        const conBoxes = document.querySelectorAll('.mouse');
        const stalker = document.querySelector('.mouse-stalker');
        const textEl = document.querySelector('.mouse_text');

        let hoverCount = 0;

        conBoxes.forEach((con) => {

            con.addEventListener('mouseenter', (e) => {
                hoverCount++;

                // ⭐ data属性からテキスト取得

                const text = con.dataset.stalkerText;
                textEl.innerHTML = text;

                stalker.style.left = `${e.clientX}px`;
                stalker.style.top = `${e.clientY}px`;

                stalker.classList.add('active');
            });

            con.addEventListener('mousemove', (e) => {
                stalker.style.left = `${e.clientX}px`;
                stalker.style.top = `${e.clientY}px`;
            });

            con.addEventListener('mouseleave', () => {
                hoverCount--;
                if (hoverCount <= 0) {
                    stalker.classList.remove('active');
                    hoverCount = 0;
                }
            });
        });
    });

}



//===============================
//    ナビリスト
//===============================

document.addEventListener("DOMContentLoaded", () => {
    const navTxt = document.querySelectorAll(".navTxt");
    const navTarget = document.querySelectorAll(".area");
    const lists = document.querySelectorAll(".navList li");

    if (!navTarget.length || !lists.length) return;

    let currentIndex = -1;

    const applyIndex = (index) => {
        if (index < 0 || index >= lists.length) return;
        if (currentIndex === index) return;

        // li の show 切替
        lists.forEach(li => li.classList.remove("show"));
        lists[index].classList.add("show");

        // テキストの max-height 切替
        navTxt.forEach(txt => (txt.style.maxHeight = "0px"));
        if (navTxt[index]) {
            navTxt[index].style.maxHeight = navTxt[index].scrollHeight + "px";
        }

        currentIndex = index;

    };

    // 「画面の50vhライン」で判定したいので、上50%/下50%を削る
    // → 中央線をまたいだ瞬間に isIntersecting が true になりやすい
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                const num = Number(entry.target.dataset.num);
                if (!Number.isFinite(num)) return;

                applyIndex(num - 1);
            });
        },
        {
            root: null,
            rootMargin: "-50% 0px -50% 0px", // ← 50vhライン基準
            threshold: 0,
        }
    );

    navTarget.forEach((el) => observer.observe(el));


});




const triggers = document.querySelectorAll('.boxItem');

let lastY = window.scrollY;

const observerTxt = new IntersectionObserver((entries) => {
    const y = window.scrollY;
    const down = y > lastY;
    lastY = y;

    entries.forEach(entry => {
        const section = entry.target.closest('.sec2');
        const con = section?.querySelector('.content');
        if (!con) return;

        if (entry.isIntersecting) {
            con.classList.add('scrollin');
        } else {
            // 👇 下スクロールでは消さない
            if (!down) {
                con.classList.remove('scrollin');
            }
        }
    });
}, {
    rootMargin: '0px 0px -40% 0px',
    threshold: 0.1
});

triggers.forEach(el => observerTxt.observe(el));



if (window.matchMedia('(max-width: 768px)').matches) {
    const con = document.querySelector('.concept .box2');
    const fixBg = document.querySelector('.concept .fixBg');
    const concept = document.querySelector('.concept');

    concept.style.height = con?.clientHeight + height * .6 + 'px';
    fixBg.style.height = con?.clientHeight + height * 2.1 + 'px';
    fixBg.style.top = height * -1.5 + 'px';
}